/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Referral_Step3_TitleInputs */

const tr_landing_referral_step3_title = /** @type {(inputs: Landing_Referral_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İkiniz de kazanın`)
};

const en_landing_referral_step3_title = /** @type {(inputs: Landing_Referral_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You both win`)
};

const de_landing_referral_step3_title = /** @type {(inputs: Landing_Referral_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beide gewinnen`)
};

const ru_landing_referral_step3_title = /** @type {(inputs: Landing_Referral_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выиграйте вдвоём`)
};

/**
* | output |
* | --- |
* | "You both win" |
*
* @param {Landing_Referral_Step3_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_referral_step3_title = /** @type {((inputs?: Landing_Referral_Step3_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Referral_Step3_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_referral_step3_title(inputs)
	if (locale === "de") return de_landing_referral_step3_title(inputs)
	if (locale === "ru") return ru_landing_referral_step3_title(inputs)
	return tr_landing_referral_step3_title(inputs)
});